import React from "react"
import styled from "styled-components"
import PageHeader from "@src/components/PageHeader"
import { Link, Switch, useLocation } from "react-router-dom"
import { SpacingY } from "@src/components/SpacingY"
import { SpacingX } from "@src/components/SpacingX"
import { useCgFeatureFlag } from "@src/useCgFeatureFlag"
import { RestrictedRoute } from "@src/components/RestrictedRoute"
import { ActionLogsScreen } from "@src/scenes/ActionLogsScreen"
import {
  WatchlistsScreen,
  WatchlistIndividualsScreen,
} from "@src/scenes/WatchlistsScreen"
import { theme } from "@elevate_security/elevate-component-library"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { selectIsEngageCustomer } from "@src/services/redux/MimecastCg"

const TabStyled = styled.div<{ active?: boolean }>`
  padding: 12px;
  color: ${theme.tabs.color.mimecastCgDefault};
  font-weight: 600;
  border-radius: 2px;

  ${(props) =>
    props.active
      ? `
    color: ${theme.tabs.active.color.mimecastCgDefault};
    border-bottom: 2px solid ${theme.tabs.active.color.mimecastCgDefault};`
      : `
    &:hover {
        color: ${theme.tabs.active.color.mimecastCgDefault};
    }`}
`

export function RiskResponseEngineHeader() {
  const { isCg, value: rolloutHumanRiskForAll } = useCgFeatureFlag(
    "rollout-show-human-risk-for-all",
    false,
  )
  const { pathname } = useLocation()
  const showTitle = isCg ? !rolloutHumanRiskForAll : true
  const { t } = useTranslation(["actionLogs", "watchlists", "translation"])
  const isEngageCustomer = useSelector(selectIsEngageCustomer)

  const routes = (
    <Switch>
      <RestrictedRoute
        path="/engagement/vision2/risk-response-engine/action-logs"
        render={() => <ActionLogsScreen showTitle={showTitle} />}
        fallbackPath="/engagement/vision2/dashboard"
        shouldRender={true}
      />
      <RestrictedRoute
        path="/engagement/vision2/risk-response-engine/watchlists/:watchlistId/individuals"
        render={() => <WatchlistIndividualsScreen showTitle={showTitle} />}
        fallbackPath="/engagement/vision2/dashboard"
        shouldRender={!isCg || isEngageCustomer}
      />
      <RestrictedRoute
        path="/engagement/vision2/risk-response-engine/watchlists"
        render={() => <WatchlistsScreen showTitle={showTitle} />}
        fallbackPath="/engagement/vision2/dashboard"
        shouldRender={!isCg || isEngageCustomer}
      />
    </Switch>
  )

  if (!isCg || !rolloutHumanRiskForAll) {
    return routes
  }

  return (
    <SpacingY size="md">
      <SpacingY>
        <PageHeader title={t("translation:riskResponseEngineTitleText")} />
        <SpacingX size="md">
          <TabStyled active={pathname.includes("/action-logs")}>
            <Link to="/engagement/vision2/risk-response-engine/action-logs">
              {t("actionLogs:actionLogsTitleText")}
            </Link>
          </TabStyled>
          {isEngageCustomer && (
            <TabStyled active={pathname.includes("/watchlists")}>
              <Link to="/engagement/vision2/risk-response-engine/watchlists">
                {t("watchlists:watchlistsTitleText")}
              </Link>
            </TabStyled>
          )}
        </SpacingX>
      </SpacingY>
      {routes}
    </SpacingY>
  )
}
